<template>
    <CRow>
        <CCol col="6" lg="6" class="offset-3">
            <br/>
            <br/>
            <br/>
            <br/>
            <br/>
            <br/>
            <CCard>
                <CCardBody>
                    <form
                        @submit.prevent="createRecord('REGISTER', { name:name, email:email, phone:phone, role_id:rol_id, password: password, sizes: vehicleTypeSizeIdFull, state_id: state_id }, false)"
                        method="post"
                    >
                        <h3>
                            {{ $t('login.register') }} {{ $t('users.label') }}
                        </h3>
                        <br>
                        <CRow>
                            <CCol col="12" lg="12">
                                <div class="col-sm-12" style="text-align: center">
                                    <img src="@/assets/images/logo_nomina.png" width="200" />
                                </div>
                            </CCol>
                            <CCol col="12" lg="12">
                                <CInput 
                                    :placeholder="$t('fields.name.placeholder')" 
                                    :label="$t('fields.name.label')" 
                                    v-model="name" 
                                    type="text" 
                                    required
                                ></CInput>
                            </CCol>
                            <CCol col="12" lg="12">
                                <CInput 
                                    :placeholder="$t('fields.whatsapp.placeholder')" 
                                    :label="$t('fields.whatsapp.label')" 
                                    v-model="phone" 
                                    type="text" 
                                    required
                                ></CInput>
                            </CCol>
                            <CCol col="12" lg="12">
                                <CInput 
                                    :placeholder="$t('fields.email.placeholder')" 
                                    :label="$t('fields.email.label')" 
                                    v-model="email" 
                                    type="text" 
                                    required
                                ></CInput>
                            </CCol>
                            <CCol col="12" lg="12">
                                <CInput 
                                    :placeholder="$t('login.input.password.placeholder')" 
                                    :label="$t('login.input.password.label')" 
                                    v-model="password" 
                                    type="password"
                                    required
                                ></CInput>
                            </CCol>
                            <CCol col="12" lg="12">
                                <CRow>
                                    <CCol col="10" lg="10">
                                        <CInput 
                                            :placeholder="$t('typeVehicles.placeholder')" 
                                            :label="$t('typeVehicles.title')" 
                                            v-model="typeVehicleSize" 
                                            type="text" 
                                            required
                                            readonly
                                        ></CInput>
                                    </CCol>
                                    <CCol col="2" lg="2" style="margin-top:20px">
                                        <CButton color="warning" class="m-2" @click="showDetail = true">
                                            <CIcon :content="updateIcon" /> {{ $t('button.options') }}
                                        </CButton>
                                    </CCol>
                                </CRow>
                            </CCol>
                            <CCol col="12" lg="12">
                                <CSelect 
                                    placeholder="Estado donde se ubica" 
                                    label="Estado donde se ubica" 
                                    :options="states"
                                    :value.sync="state_id"
                                    :plain="true"
                                ></CSelect>
                            </CCol>
                       </CRow>
                        <CRow>
                            <CCol col="12" lg="12" class="text-right">
                                <CButton color="primary" to="/login" class="m-2">
                                    <CIcon :content="backIcon" /> {{ $t('button.back') }}
                                </CButton>
                                <CButton color="success" type="submit" class="m-2">
                                    <CIcon :content="addIcon" /> {{ $t('button.create') }}
                                </CButton>
                            </CCol>
                        </CRow>
                    </form>
                </CCardBody>
            </CCard>
        </CCol>
        <CModal
            color="warning"
            :show.sync="showDetail"
            :title="$t('typeVehicles.title')"
        >
            <div>
                <CRow v-for="typeVehicle in typeVehicles" :key="typeVehicle.id" >
                    <div class="col-sm-12">
                        <label class="label-detail" style="font-weight: bold">
                            {{typeVehicle.name}}
                        </label>
                        <hr/>
                    </div>
                    <div class="col-sm-12" v-for="size in typeVehicle.sizes" 
                        :key="size.id" style="text-align: center; cursor: pointer;">
                        <input type="checkbox" :value="size.id" 
                            v-model="vehicleTypeSizeId" @click="onSelectTipeVehicleSize(typeVehicle, size)"/>
                        <label class="label-detail">
                            {{size.name}}
                        </label>
                    </div>
                </CRow>
            </div>
        </CModal>
    </CRow>
</template>

<script>
import axios from 'axios'
import catalog from '../../hooks/catalogs';
import { cilSync, cilPlus, cilArrowLeft } from '@coreui/icons';

export default {
    name: 'Register',
    mixins: [catalog],
    data() {
        return {
            addIcon: cilPlus,
            updateIcon: cilSync,
            backIcon: cilArrowLeft,
            name: null,
            states: [],
            phone: null,
            email: null,
            rol_id: null,
            state_id: null,
            password: null,
            typeVehicles: [],
            showState: false,
            showDetail: false,
            showTypeVehicle: false,
            vehicleTypeSizeId: [],
            vehicleTypeSizeName: [],
            vehicleTypeSizeIdFull: [],
            typeVehicleSize: null,
            roles: [
                {
                    value: 2,
                    label: "Soy Transportista",
                },
                {
                    value: 4,
                    label: "Soy Proveedor",
                },
                {
                    value: 5,
                    label: "Soy Logistico",
                }
            ],
        }
    },
    methods: {
        onSelectTipeVehicleSize(vehicleTypeSize, size) {
            setTimeout(() => {
                var name = vehicleTypeSize.name + " - " + size.name;

                if (this.vehicleTypeSizeName.includes(name)) {
                    const index = vehicleTypeSizeName.indexOf(name);

                    if (index !== -1) {
                        this.vehicleTypeSizeName.splice(index, 1);
                    }
                } else {
                    this.vehicleTypeSizeName.push(name);
                }

                this.vehicleTypeSizeId.forEach((element) => {
                    this.vehicleTypeSizeIdFull.push({id: element});
                });

                this.vehicleTypeSizeName.forEach((element) => {
                    this.typeVehicleSize = (this.vehicleTypeSizeName ?? "") + element;
                });
            }, 100);
        },
        onSelectRole(event) {
            this.showState = (this.rol_id == 2);
            this.showTypeVehicle = (this.rol_id == 2 || this.rol_id == 5);
        },
    },
    async mounted() {
        let self = this;

        if (this.isEditing) {
            axios.get(`api/charges/${this.$route.params.id}`)
                .then(response => {
                    self.name = response.data.data.name;
                }).catch(error => {
                    if (error.response.status === 401) {
                        self.$router.push({ path: '/login' });
                    } else {
                        self.$toast.error(error.response.data.message);
                    }
                });
        }

        axios.get(`type-vehicle`)
            .then(response => {
                response.data.forEach(function(record){
                    self.typeVehicles.push(record);
                });
            }).catch(error => {
                if (error.response.status === 401) {
                    self.$router.push({ path: '/login' });
                } else {
                    self.$toast.error(error.response.data.message);
                }
            });

        axios.get(`states`)
            .then(response => {
                response.data.forEach(function(record){
                    self.states.push({
                        value: record.id,
                        label: record.name,
                    });
                });
            }).catch(error => {
                if (error.response.status === 401) {
                    self.$router.push({ path: '/login' });
                } else {
                    self.$toast.error(error.response.data.message);
                }
            });
    }
}
</script>
